import { createSlice } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'

import {
  markAsOtpAttempt,
  markAsOtpLimitReached,
  resetOtpLimitReached,
  unmarkAsOtpLimitReached,
} from './shared/otp'

const initialState = {
  attempt: 0,
  email: '',
  lastResendAttemptTime: 0,
  rateLimitLockedTime: 0,
  isRateLimitReached: false,
  isInputRateLimitReached: false,
}

const emailOtoSlice = createSlice({
  name: 'emailOtp',
  initialState,
  extraReducers(builder) {
    builder.addCase(PURGE, () => {
      return initialState
    })
  },
  reducers: {
    setCurrentVerifyEmail: (state, action) => {
      state.email = action.payload
    },
    clearVerifyEmailState: () => {
      return initialState
    },
    markAsVerifyEmailAttempt: markAsOtpAttempt,
    resetVerifyEmailLimitReached: resetOtpLimitReached,
    markAsVerifyEmailLimitReached: (state, action) => {
      markAsOtpLimitReached(state, action.payload)
    },
    unmarkAsVerifyEmailLimitReached: (state) => {
      state.isInputRateLimitReached = false
      unmarkAsOtpLimitReached(state)
    },
    markAsVerifyEmailInputRateLimitReached: (state, action) => {
      markAsOtpLimitReached(state, action?.payload)

      state.isRateLimitReached = false
      state.isInputRateLimitReached = true
    },
  },
})

export const {
  setCurrentVerifyEmail,
  markAsVerifyEmailAttempt,
  clearVerifyEmailState,
  markAsVerifyEmailLimitReached,
  unmarkAsVerifyEmailLimitReached,
  resetVerifyEmailLimitReached,
  markAsVerifyEmailInputRateLimitReached,
} = emailOtoSlice.actions

export default emailOtoSlice.reducer
